import { RequestSender } from "./helpers";

type PopulateClassWalletSessionItemsInput = {
  readonly orderId: string;
  readonly items: {
    readonly priceLookupKey: string;
    readonly quantity: number;
  }[];
};

async function populateClassWalletSessionItems(
  request: RequestSender,
  { orderId, items }: PopulateClassWalletSessionItemsInput,
): Promise<void> {
  const response = await request<any>(
    "put",
    `/class-wallet/order-sessions/${encodeURIComponent(orderId)}/items`,
    {
      items,
    },
  );
  if (response.status !== 204) {
    throw new Error(response.data.message);
  }
}

export type { PopulateClassWalletSessionItemsInput };
export default populateClassWalletSessionItems;
